import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'dbm-dropdown',
    template: require('./dbm-dropdown.component.html'),
    styles: [require('./dbm-dropdown.component.scss')]
})
export class DbmDropdownComponent implements OnInit {

    @Input() public listData: string[] = [];
    @Input() public placeholder = '';
    @Input() public isDefault: boolean = false;
    @Output() public selectedValue: EventEmitter<string> = new EventEmitter<string>();
    public isMenuToggle = false;

    constructor() {
    }

    public ngOnInit(): void {
        if (this.listData?.length === 1 || this.isEmpty(this.placeholder)) {
            this.selectValue(this.listData[0]);
        }
    }

    public toggleMenu(): void {
        this.isMenuToggle = !this.isMenuToggle;
    }

    public selectValue(value: string): void {
        this.placeholder = this.isDefault ? this.placeholder : value;
        this.selectedValue.emit(value);
    }

    public close(): void {
        this.isMenuToggle = false;
    }

    private isEmpty(str): boolean {
        return (!str || 0 === str.length);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-dropdown/dbm-dropdown.component.ts